function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1018.749 -552.17)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1027.582,559.45h3.336v2.41a.662.662,0,0,0,1.136.456l4.5-4.5,0,0a.663.663,0,0,0,0-.937l-4.5-4.5a.653.653,0,0,0-.466-.2h-.007a.663.663,0,0,0-.662.666v2.4h-3.336a1.149,1.149,0,0,0-1.15,1.148v1.92h0A1.149,1.149,0,0,0,1027.582,559.45Zm.35-2.721h2.986a1.5,1.5,0,0,0,1.5-1.5v-.379l2.49,2.489-2.49,2.49v-.379a1.5,1.5,0,0,0-1.5-1.5h-2.986Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1035.257,567.1a.747.747,0,0,1-.746.746h-1.492a.746.746,0,0,0-.746.746v1.589l-3.315-2.206a.746.746,0,0,0-.414-.126h-7.557a.746.746,0,0,1-.746-.746v-8.953a.746.746,0,0,1,.746-.746h4.395v-1.491h-4.395a2.24,2.24,0,0,0-2.238,2.237v8.953a2.239,2.239,0,0,0,2.238,2.238h7.332l4.287,2.858a.746.746,0,0,0,1.034-.208.737.737,0,0,0,.125-.412v-2.241h.746a2.241,2.241,0,0,0,2.238-2.238v-6.713h-1.492Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1030.867,564.639h-7.824a.554.554,0,0,0,0,1.108h7.824a.554.554,0,0,0,0-1.108Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1027.546,561.844h-4.5a.553.553,0,0,0,0,1.107h4.5a.553.553,0,0,0,0-1.107Z"
}));

var SvgForceSendSms = function SvgForceSendSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20.158,
    viewBox: "0 0 18 20.158",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForceSendSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/force-send-sms.a652971c.svg";
export { ForwardRef as ReactComponent };